export default __webpack_public_path__ + "static/media/image8.66147e34.png";